<template>
  <MenuComponent
    :custom_title="$t('Menu.SavedSettings')"
    :filtred_count="settingsList && settingsList.length">
    <template #filter>
      <sButton
        small
        @click="clearAll">
        Видалити все
      </sButton>
    </template>
    <template #items>
      <div>
        <EmptyBlock
          v-if="!settingsList || settingsList.length == 0"
          style="max-width: 1024px; width: 100%; margin: 0 auto;"
          :text="$t('Tenders.NoData')"/>
        <v-data-table
          v-else
          id="savedSettings"
          calculate-widths
          class="mt-4"
          disable-pagination
          fixed-header
          :headers="headers"
          :hide-default-footer="true"
          item-key="key"
          :items="settingsList"
          style="max-width: 1024px; width: 100%; margin: 0 auto;">
          <template #[`item.key`]="{ item }">
            <div style="overflow: auto">
              <div>{{ item.key }}</div>
              <div
                v-if="typeLocalSettings[item.key]"
                style="font-size: 12px; opacity: 0.5;">
                {{ typeLocalSettings[item.key] }}
              </div>
            </div>
          </template>
          <template #[`item.value`]="{ item }">
            <JsonViewer :value="item.value"/>
          </template>
          <template #[`item.dateCreated`]="{ item }">
            {{ item.dateCreated ? $d(new Date(item.dateCreated), 'longDate') : '-' }}
          </template>
          <template #[`item.expiresAt`]="{ item }">
            {{ item.expiresAt ? $d(new Date(item.expiresAt), 'longDate') : '-' }}
          </template>
          <template #[`item.menu`]="{ item }">
            <div class="table-actions">
              <sButton
                data-qa="delete"
                icon="delete"
                :loading="item.loading"
                small
                type="text"
                @click="deleteSetting(item)"/>
            </div>
          </template>
        </v-data-table>
      </div>
    </template>
  </MenuComponent>
</template>
<script>
import MenuComponent from 'pages/templates/MenuComponent.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import JsonViewer from 'components/common/elements/JsonViewer.vue'

import { storageMixin } from 'mixins'
import textFunctions from 'mixins/textFunctions'

import SettingsApi from '@/api/settingsApi'
const settingsApi = new SettingsApi()

import IndexedDBService from '@/helpers/IndexedDBService'

export default {
  name: 'personal-settings-page',
  mixins: [ storageMixin, textFunctions ],
  data() {
    return {
      headers: [
        {text: 'key', value: 'key', width: '10%', disableFilter: true, sortable: true,
          order: 3},
        {text: 'value', value: 'value', width: 'calc(90% - 50px)', sortable: true,
          order: 1},
        /*{text: 'dateCreated', value: 'dateCreated', width: '200px', sortable: true},
        {text: 'expiresAt', value: 'expiresAt', width: '200px', sortable: true},*/
        {text: '', value: 'menu', width: '50px', sortable: true, }
      ],
      settingsList: [],
    }
  },
  methods: {
    clearAll() {
      settingsApi.clearAllDBStorage()
        .then((result) => {
          if (result) {
            IndexedDBService.setItem(IndexedDBService.storeNames.dopProps, {key: 'errorState', value: false})
            location.reload(true)
          }
        })
        .catch(() => {
          //
        })
    },
    getAllSettings() {
      IndexedDBService.readAllItems('itemProps')
        .then((result) => {
          this.settingsList = result
        })
    },
    deleteSetting(item) {
      const index = this.settingsList.findIndex(i => i.key === item.key)
      this.$set(this.settingsList[index], 'loading', true)
      this.$_deleteDBStorage(item.key)
        .then((result) => {
          if (result) {
            this.settingsList.splice(index, 1)
          }
        })
    }
  },
  components: {
    EmptyBlock,
    JsonViewer,
    MenuComponent,
  },
  created() {
    this.getAllSettings()
  },
}
</script>
<style scoped lang="scss">
::v-deep #savedSettings {
  th, td {
    border-right: thin solid var(--v-main__green-base) !important;
  }
}
.table-actions {
  //position: absolute;
  right: 29px;
  z-index: 1;
}
</style>
